import React from "react";
import { ApolloProvider } from "@apollo/react-common";

import { useApolloClient } from "../hooks";

interface ApolloProviderWrapperProps {
    children: React.ReactNode;
    graphqlEndpoint?: string;
}

export const ApolloProviderWrapper: React.FC<ApolloProviderWrapperProps> = ({
    children,
    graphqlEndpoint,
}) => {
    const client = useApolloClient({ graphqlEndpoint });

    return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
